import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pettypeforum',
  pure: false,
})
export class PettypeforumPipe implements PipeTransform {

  transform(data: any, ptype: any): any {
    if (!ptype) {
     return data;
   }else {
       let  out6 = [];
           for ( let d in data ) {
               if (data[d].pet_type == ptype) {
                 out6.push(data[d]);
               }
           }
   return out6;
   }
  }

}
